import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Trans } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  title: {
    ...theme.fonts.h3,
    whiteSpace: 'pre-line',
  },
  iconContainer: {
    height: theme.marginBase * 8,
    width: theme.marginBase * 8,
    margin: 'auto',
    borderRadius: '50%',
    backgroundColor: theme.colors.red,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    marginBottom: theme.marginBase * 4,
  },
  icon: {
    fontSize: theme.marginBase * 6,
    color: theme.colors.white,
  },
  centered: {
    textAlign: 'center',
  },
}));

interface Props {
  title: string;
  children?: React.ReactNode;
}

export const FailureScreen = ({ title, children }: Props) => {
  const theme: any = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.centered}>
      <div className={classes.iconContainer}>
        <i className={classnames(classes.icon, 'ri-close-line')} />
      </div>
      <h1 className={classes.title}>{title}</h1>
      {children}
    </div>
  );
};
